@if (this.mForm.form.config) {
  <header>
    @if (headerLinks.length > 0) {
      <ul>
        @for (link of headerLinks; track link; let fi = $index) {
          <li >
            <a href="{{link.url | translate}}" target="_blank">{{link.text | translate | ucFirst}}</a>
            @if (headerLinks[fi+1]) {
              <span class="separator"></span>
            }
          </li>
        }
      </ul>
    }
    @if (this.mForm.form.config.passengerLogin) {
      <app-loggedin-menu></app-loggedin-menu>
    }
    <div class="country-select-wrapper">
      <app-country-select></app-country-select>
    </div>
  </header>
}

<router-outlet></router-outlet>

